import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/WhiteRunt/ProductShowcase";
import Footer from "../../components/Footer";
import Cta from "../../components/Cta";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet";

const WhiteRuntz = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Helmet>
        <title>White Runtz Strain - Frosty & Euphoric Cannabis | BeyondBloom™</title>
        <meta
          name="description"
          content="White Runtz features frosty, candy-like buds with a euphoric high. A premium cannabis strain for ultimate relaxation and joy."
        />
        <meta
          name="keywords"
          content="White Runtz strain, Runtz weed, euphoric cannabis, premium hybrid, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="White Runtz Strain - Frosty & Euphoric Cannabis | BeyondBloom™" />
        <meta
          property="og:description"
          content="White Runtz features frosty, candy-like buds with a euphoric high. A premium cannabis strain for ultimate relaxation and joy."
        />
        <meta property="og:image" content="/images/Runtz_white.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/white-runtz" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="White Runtz Strain - Frosty & Euphoric Cannabis | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="White Runtz features frosty, candy-like buds with a euphoric high. A premium cannabis strain for ultimate relaxation and joy."
        />
        <meta name="twitter:image" content="/images/Runtz_white.png" />
      </Helmet>
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default WhiteRuntz;
